import SurveyBuilderContainer from './survey_builder_container';

const SurveyBuilder = SurveyBuilderContainer;

export default SurveyBuilder;
